<template>
  <ConfigErrorBoundary>
    <FileConverter
      :config="converterConfig"
      @batch-created="handleBatchCreated"
      @job-completed="handleJobCompleted"
      @batch-cleared="handleBatchCleared"
      @error="handleError"
      @credits-updated="handleCreditsUpdated"
    />
  </ConfigErrorBoundary>
</template>

<script setup lang="ts">
import FileConverter from './FileConverter.vue';
import ConfigErrorBoundary from './ConfigErrorBoundary.vue';
import { parseAndValidateConverterConfig } from '../utils/ConfigValidator';

const converterConfig = parseAndValidateConverterConfig('tar-gz-to-zip-converter', 'TAR.GZ to ZIP');

function handleBatchCreated(batchId: string) {
  console.log('[TAR.GZ to ZIP Converter] Batch created:', batchId);
}

function handleJobCompleted(jobId: string) {
  console.log('[TAR.GZ to ZIP Converter] Job completed:', jobId);
}

function handleBatchCleared() {
  console.log('[TAR.GZ to ZIP Converter] Batch cleared');
}

function handleError(error: Error) {
  console.error('[TAR.GZ to ZIP Converter] Error:', error);
}

function handleCreditsUpdated(credits: number) {
  console.log('[TAR.GZ to ZIP Converter] Credits updated:', credits);
}
</script>
